"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectDependency_wsClientSyncFactory = exports.stopWsClientSync = exports.setupWsClientSync = void 0;
const ws_client_sync_1 = require("@wranggle/ws-client-sync");
const _wsClientByName = {};
const DefaultConnectionName = 'singleWsTopicSyncBackend_$w_';
const AttribForConnectionName = '__connectionName_$w_';
let _wsClientSyncFactory;
function setupWsClientSync(args) {
    const { fetchConnectionInstructions, wsClientSyncOpts, setDataBucketStateByVarName, setDataBucketTopicInfoByVarName } = args;
    const connectionName = args.connectionName || DefaultConnectionName;
    if (_wsClientByName[connectionName]) {
        return _wsClientByName[connectionName];
    }
    const clientSyncOpts = Object.assign({ fetchConnectionInstructions }, (wsClientSyncOpts || {}));
    const wsClientSync = _wsClientSyncFactory ? _wsClientSyncFactory(clientSyncOpts) : new ws_client_sync_1.WsClientSync(clientSyncOpts);
    wsClientSync[AttribForConnectionName] = connectionName;
    _setupSyncEventStateObserverAndInitialData({
        wsClientSync,
        setDataBucketStateByVarName,
        setDataBucketTopicInfoByVarName,
    });
    _wsClientByName[connectionName] = wsClientSync;
    return wsClientSync;
}
exports.setupWsClientSync = setupWsClientSync;
function stopWsClientSync(clientOrName) {
    if (!clientOrName) {
        console.warn('WsClientSync instance or connectionName required');
        return;
    }
    const connectionName = typeof clientOrName === 'string' ? clientOrName : clientOrName[AttribForConnectionName];
    if (!connectionName) {
        console.warn('Trying to stop WsClientSync but not found or already stopped:', connectionName);
        return;
    }
    const wsClientSync = _wsClientByName[connectionName];
    delete _wsClientByName[connectionName];
    wsClientSync && wsClientSync.stop();
}
exports.stopWsClientSync = stopWsClientSync;
function _setupSyncEventStateObserverAndInitialData(args) {
    const { wsClientSync, setDataBucketStateByVarName, setDataBucketTopicInfoByVarName } = args;
    const onStateChange = (bucket, eventData) => {
        const { state } = eventData;
        setDataBucketStateByVarName((prevState) => (Object.assign(Object.assign({}, (prevState || {})), { [bucket.getAuthorVarName()]: state })));
    };
    const onBucketReady = (bucket, eventData) => {
        const { wsTopic, authorVarName } = eventData;
        setDataBucketTopicInfoByVarName((prevState) => (Object.assign(Object.assign({}, (prevState || {})), { [bucket.getAuthorVarName()]: {
                wsTopic,
                authorVarName,
                status: bucket.getTopicJoinStatus(),
            } })));
    };
    wsClientSync.on(ws_client_sync_1.WsClientSyncEvent.StateChange, onStateChange);
    wsClientSync.on(ws_client_sync_1.WsClientSyncEvent.DataBucketReady, onBucketReady);
    // initialize existing data for the case of the react context/provider rendering after wsClientSync already connected and synced
    setDataBucketStateByVarName(wsClientSync.getStateByVarName());
    (wsClientSync.getAllDataBuckets() || []).forEach(bucket => {
        if (bucket.isReady()) {
            onBucketReady(bucket, {
                wsTopic: bucket.getWsTopic(),
                authorVarName: bucket.getAuthorVarName(),
            });
        }
    });
}
function injectDependency_wsClientSyncFactory(val) {
    _wsClientSyncFactory = val;
}
exports.injectDependency_wsClientSyncFactory = injectDependency_wsClientSyncFactory;
//# sourceMappingURL=setup-ws-client-sync.js.map